<template>
  <div id="penjurusan">
    <Splash v-if="isSplash == true" />
    <div id="penjurusan-detail" v-if="isSplash == false">
      <v-row no-gutters>
        <v-col>
          <div
            id="landing-detail"
            class="d-flex flex-row justify-center align-start"
          >
            <v-container>
              <v-row no-gutters>
                <v-app-bar
                  elevation="0"
                  style="background: none !important"
                  class="menu-bar"
                >
                  <v-avatar color="primary" size="50">
                    <v-img
                      contain
                      lazy-src="../../assets/img/logo-teman-bakat.png"
                      max-height="150"
                      max-width="250"
                      src="../../assets/img/logo-teman-bakat.png"
                    ></v-img>
                  </v-avatar>
                  <template>
                    <v-tabs align-with-title v-model="tab">
                      <v-tab href="http://temanbakat.id" target="_blank">
                        BERANDA
                      </v-tab>
                      <v-tab
                        v-for="item in menuItems"
                        :key="item.name"
                        @click="onItem = item.id"
                      >
                        {{ item.text }}
                      </v-tab>
                    </v-tabs>
                  </template>
                </v-app-bar>
              </v-row>
              <Menu />
              <v-row
                no-gutters
                class="toolbar animate__animated animate__bounce"
              >
                <v-col>
                  <div class="d-flex pa-5 justify-start align-center">
                    <div>
                      <v-btn
                        class="mx-2"
                        fab
                        color="white"
                        small
                        elevation="2"
                        @click="
                          backToList()
                            ? $router.go(-1)
                            : $router.push('/penjurusan')
                        "
                      >
                        <v-icon dark> mdi-chevron-left </v-icon>
                      </v-btn>
                    </div>
                    <div width="50%">
                      <v-menu offset-y nudge-bottom="10px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            :color="filterText.length ? '#23003A' : 'white'"
                            :dark="filterText.length ? true : false"
                            class="ml-3 font-weight-bold rounded-xl"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon class="mr-2">mdi-filter-variant</v-icon>
                            <v-text
                              :color="filterText.length ? '#23003A' : 'white'"
                              :dark="filterText.length ? true : false"
                              >Filter Jurusan</v-text
                            >
                            <v-icon class="ml-2"
                              >mdi-arrow-down-drop-circle</v-icon
                            >
                          </v-btn>
                        </template>
                        <v-card style="z-index: 3">
                          <div class="pa-5">
                            <div class="font-weight-bold">Kategori Jurusan</div>
                            <div>
                              <v-divider></v-divider>
                            </div>
                            <div class="d-flex">
                              <v-row no-gutters>
                                <v-col cols="12" md="6">
                                  <div
                                    v-for="(item, i) in kategori1"
                                    :key="i"
                                    class="pa-2"
                                    @click="filterKategori(item)"
                                    style="cursor: pointer"
                                  >
                                    {{ item.text }}
                                  </div>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <div
                                    v-for="(item, i) in kategori2"
                                    :key="i"
                                    class="pa-2"
                                    @click="filterKategori(item)"
                                    style="cursor: pointer"
                                  >
                                    {{ item.text }}
                                  </div>
                                </v-col>
                              </v-row>
                            </div>
                          </div>
                        </v-card>
                      </v-menu>
                    </div>
                    <div class="search-detail" style="width: 50%">
                      <v-text-field
                        placeholder="Mau Cari Jurusan Lain?"
                        solo
                        flat
                        rounded
                        hide-details
                        @keyup="getRecommend"
                        class="rou ml-5"
                        background-color="#E8E5EB"
                        v-model="search"
                      ></v-text-field>
                    </div>
                    <div class="search-detail">
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        dark
                        color="#41006B"
                        elevation="2"
                        @click="searching"
                      >
                        <v-icon dark> mdi-magnify </v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row v-if="search != ''" no-gutters>
                <v-col md="12" class="d-flex justify-center align-center">
                  <v-card
                    width="41%"
                    height="200px"
                    style="
                      overflow: auto;
                      position: absolute;
                      top: 3.7%;
                      z-index: 5;
                    "
                    class="ml-12 mr-n6 card-recomended"
                  >
                    <div v-if="recomendedJurusan">
                      <div
                        class="px-5 pt-3 pb-1 d-flex item-recomended"
                        v-for="item in recomendedJurusan"
                        :key="item.id"
                        @click="onClickRecomended(item.jurusan_nama)"
                      >
                        <v-icon class="mr-2">mdi-magnify</v-icon>
                        <v-text>{{ item.jurusan_nama }}</v-text>
                      </div>
                    </div>
                    <div
                      v-if="recomendedJurusan.length == 0"
                      class="d-flex justify-center align-center"
                    >
                      <div class="mt-12">Data tidak tersedia...</div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
              <v-row style="z-index: 2" no-gutters>
                <v-row no-gutters>
                  <v-col
                    cols="12"
                    md="12"
                    v-if="filterText.length !== 0"
                    class="d-flex align-center pa-5 ml-2"
                  >
                    <div v-for="filter in filterText" :key="filter">
                      <v-card class="pa-2 rounded-lg mx-2" color="#9C6FB5" dark>
                        {{ filter }}
                        <v-icon
                          dark
                          style="cursor: pointer"
                          @click="removeFilter(filter)"
                          >mdi-close-circle</v-icon
                        >
                      </v-card>
                    </div>
                  </v-col>
                </v-row>
              </v-row>
              <v-row
                no-gutters
                v-if="activeRowDetail"
                class="animate__animated animate__bounce"
              >
                <v-col cols="12" md="12" sm="12">
                  <div class="d-flex justify-center">
                    <v-card
                      class="d-flex left-detail rounded-lg"
                      flat
                      color="#420B89"
                      dark
                    >
                      <div class="pa-5">
                        <div>
                          <div
                            v-if="dataDetail"
                            class="text-h4 font-weight-bold unselectable"
                          >
                            {{ dataDetail.jurusan_nama }}
                          </div>
                        </div>
                        <div class="pa-2">
                          <div class="d-flex">
                            <div class="d-flex mx-2">
                              <div>
                                <v-avatar color="primary" size="40">
                                  <v-img
                                    contain
                                    lazy-src="../../assets/img/logo-teman-bakat.png"
                                    max-height="150"
                                    max-width="250"
                                    :src="dataDetail.image"
                                  ></v-img>
                                </v-avatar>
                              </div>
                              <div class="ml-2 unselectable">
                                <div>Kategori:</div>
                                <div>
                                  {{ dataDetail.kategori_jurusan_id }}
                                </div>
                              </div>
                            </div>
                            <div class="d-flex mx-2">
                              <div>
                                <v-avatar color="primary" size="40">
                                  <v-img
                                    contain
                                    lazy-src="../../assets/img/logo-teman-bakat.png"
                                    max-height="150"
                                    max-width="250"
                                    src="../../assets/img/logo-teman-bakat.png"
                                  ></v-img>
                                </v-avatar>
                              </div>
                              <div class="ml-2 unselectable">
                                <div>Pelajaran terkait:</div>
                                <div
                                  v-for="pelajaran in dataDetail.pelajaran_terkait_id"
                                  :key="pelajaran"
                                >
                                  {{ pelajaran }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card>
                    <div class="banner_cover ml-n12">
                      <v-card flat class="rounded-lg">
                        <v-img
                          class="white--text align-end"
                          height="50vh"
                          :src="dataDetail.image_jurusan"
                        ></v-img>
                      </v-card>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </div>
          <div
            v-if="activeRowDetail"
            class="blank_div"
            style="width: 100%; background-color: #dae8ea; height: 40vh"
          ></div>
          <div
            id="detail"
            v-if="activeRowDetail"
            class="animate__animated animate__pulse"
          >
            <v-container>
              <v-row no-gutters class="mb-5">
                <v-col cols="12" md="12">
                  <div class="px-12">
                    <v-card
                      class="rounded-b-0 rounded-lg py-3 px-7 text-center"
                      :style="`background:${dataDetail.base_color};color:white;width:max-content`"
                      dark
                      flat
                    >
                      <b class="label_card">Deskripsi Jurusan</b>
                    </v-card>
                  </div>
                  <div class="card_2lane">
                    <v-card class="rounded-lg" flat>
                      <div class="pa-5 text-justify unselectable">
                        {{ dataDetail.minat }}
                      </div>
                    </v-card>
                  </div>
                </v-col>
              </v-row>
              <v-row no-gutters class="mb-5">
                <v-col cols="12" md="12">
                  <div class="px-12">
                    <v-card
                      class="rounded-b-0 rounded-lg py-3 px-7 text-center"
                      :style="`background:${dataDetail.base_color};color:white;width:max-content`"
                      color="#72239E"
                      dark
                      flat
                    >
                      <b class="label_card">Kenapa Pilih Jurusan Ini?</b>
                    </v-card>
                  </div>
                  <div class="card_2lane">
                    <v-card class="rounded-lg" flat>
                      <div class="pa-5 text-justify unselectable">
                        {{ dataDetail.alasan }}
                      </div>
                    </v-card>
                  </div>
                </v-col>
              </v-row>
              <!-- content sebelahan -->
              <div class="temp_content">
                <div class="half">
                  <div class="mb-5">
                    <div class="px-12">
                      <v-card
                        class="rounded-b-0 rounded-lg py-3 px-7 text-center"
                        :style="`background:${dataDetail.base_color};color:white;width:max-content`"
                        color="#72239E"
                        dark
                        flat
                      >
                        <b class="label_card">Apa Saja yang Akan Dipelajari?</b>
                      </v-card>
                    </div>
                    <div class="card_2lane">
                      <v-card flat class="rounded-lg">
                        <ol class="px-12 py-5 unselectable">
                          <li
                            v-for="dipelajari in dataDetail.mata_kuliah_id"
                            :key="dipelajari"
                          >
                            {{ dipelajari }}
                          </li>
                        </ol>
                      </v-card>
                    </div>
                  </div>

                  <div class="mb-5">
                    <div class="px-12">
                      <v-card
                        class="rounded-b-0 rounded-lg py-3 px-7 text-center"
                        :style="`background:${dataDetail.base_color};color:white;width:max-content;`"
                        color="#72239E"
                        dark
                        flat
                      >
                        <b class="label_card">Prospek Kerja</b>
                      </v-card>
                    </div>
                    <div class="card_2lane">
                      <v-card flat class="rounded-lg">
                        <div
                          class="pa-5 text-justify unselectable"
                          v-html="dataDetail.prospek_kerja_desc"
                          style="white-space: pre-wrap"
                        ></div>
                        <div
                          v-if="
                            dataDetail.prospek_kerja !== null ||
                            dataDetail.prospek_kerja.length !== 0
                          "
                        >
                          <ol class="px-12 pb-5 mt-n5 unselectable">
                            <li
                              v-for="prospek in dataDetail.prospek_kerja"
                              :key="prospek"
                            >
                              {{ prospek }}
                            </li>
                          </ol>
                        </div>
                      </v-card>
                    </div>
                  </div>
                </div>
                <div class="half">
                  <div class="mb-5">
                    <div class="px-12">
                      <v-card
                        class="rounded-b-0 rounded-lg py-3 px-7 text-center"
                        :style="`background:${dataDetail.base_color};color:white;width:max-content;`"
                        flat
                        color="#72239E"
                        dark
                      >
                        <b class="label_card">Karakter yang Sesuai</b>
                      </v-card>
                    </div>
                    <div class="card_2lane">
                      <v-card class="rounded-lg" flat>
                        <div class="px-5 pt-5">
                          {{ dataDetail.karakter_id_desc }}
                        </div>
                        <ol class="px-12 py-5 unselectable">
                          <li
                            v-for="karakter in dataDetail.karakter_id"
                            :key="karakter"
                          >
                            {{ karakter }}
                          </li>
                        </ol>
                      </v-card>
                    </div>
                  </div>
                  <div class="mb-5">
                    <div class="px-12">
                      <v-card
                        class="rounded-b-0 rounded-lg py-3 px-7 text-center"
                        :style="`background:${dataDetail.base_color};color:white;width:max-content;`"
                        color="#72239E"
                        dark
                        flat
                      >
                        <b class="label_card">Jurusan Terkait</b>
                      </v-card>
                    </div>
                    <div class="card_2lane">
                      <v-card flat class="rounded-lg">
                        <ol class="px-12 py-5 unselectable">
                          <li
                            v-for="jurusan in dataDetail.jurusan_terkait_id"
                            :key="jurusan"
                          >
                            {{ jurusan }}
                          </li>
                        </ol>
                      </v-card>
                    </div>
                  </div>
                </div>
              </div>
            </v-container>
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters v-if="activeRowData" class="pa-2">
        <v-col
          v-for="jurusan in dataJurusan"
          :key="jurusan.id"
          cols="12"
          md="4"
          sm="12"
        >
          <div class="pa-3">
            <v-card
              class="ma-auto rounded-xl"
              @click="toDetail(jurusan.id)"
              height="400px"
            >
              <v-img
                class="white--text align-end"
                height="200px"
                :src="jurusan.image_jurusan"
              >
              </v-img>
              <v-card-text class="text--primary rounded-xl" height="100%">
                <div>
                  <div style="max-width: 80%" class="rounded-lg">
                    <div
                      class="badges rounded-lg"
                      :style="`background:${jurusan.base_color};color:white;`"
                    >
                      {{ jurusan.kategori_jurusan_id }}
                    </div>
                  </div>
                  <div style="z-index: 10">
                    <div class="text-h6">{{ jurusan.jurusan_nama }}</div>
                    <div class="d-flex">
                      <div>
                        <v-avatar color="primary" size="40">
                          <v-img
                            contain
                            lazy-src="../../assets/img/logo-teman-bakat.png"
                            max-height="150"
                            max-width="250"
                            src="../../assets/img/logo-teman-bakat.png"
                          ></v-img>
                        </v-avatar>
                      </div>
                      <div class="ml-2">
                        <div>Pelajaran terkait:</div>
                        <div
                          v-for="pelajaran in jurusan.pelajaran_terkait_id"
                          :key="pelajaran"
                        >
                          {{ pelajaran }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </div>
        </v-col>
      </v-row>
      <v-row
        class="d-flex justify-center align-center mt-12"
        style="width: 100%"
        v-if="
          dataJurusan.length == 0 && search !== '' && filterText.length == 0
        "
        no-gutters
      >
        <p style="color: #23003a; text-align: center">
          Yah, jurusan yang kamu cari tidak ada! Coba gunakan kata kunci lain.
        </p>
      </v-row>
      <v-row
        v-if="
          dataJurusan.length == 0 && search !== '' && filterText.length == 0
        "
        no-gutters
      >
        <div class="d-flex justify-center align-center" style="width: 100%">
          <v-img
            contain
            lazy-src="../../assets/img/penjurusan/no_data.png"
            max-height="325"
            max-width="300"
            src="../../assets/img/penjurusan/no_data.png"
          ></v-img>
        </div>
      </v-row>
    </div>
    <banner-bottom
      :redaksi="'Masih Bingung dan butuh Informasi Lebih Lanjut Terkait Jurusan Kuliah?'"
    />
    <Footer v-if="isSplash == false" />
  </div>
</template>

<script>
import Footer from "../../components/penjurusan/Footer.vue";
import Splash from "../../components/penjurusan/Splash.vue";
import Menu from "../../components/penjurusan/Menu.vue";
import BannerBottom from "./bannerBottom.vue";

export default {
  components: {
    Footer,
    Splash,
    Menu,
    BannerBottom,
  },
  name: "PenjurusanDetail",
  data: () => ({
    onItem: 2,
    menuItems: [
      // { id: 1, name: "beranda", text: "Beranda" },
      { id: 2, name: "cari-jurusan", text: "Cari Jurusan" },
      // { id: 3, name: "bantuan", text: "Bantuan" },
    ],
    tab: 1,
    kategori1: [
      {
        text: "Budaya & Bahasa",
      },
      {
        text: "Ekonomi & Bisnis",
      },
      {
        text: "Kesehatan",
      },
      {
        text: "Komputer & Teknologi",
      },
      {
        text: "Pendidikan",
      },
      {
        text: "Teknik",
      },
    ],
    kategori2: [
      {
        text: "Pertanian",
      },
      {
        text: "Profesi & Ilmu Terapan",
      },
      {
        text: "Sains",
      },
      {
        text: "Seni",
      },
      {
        text: "Sosial Humaniora",
      },
    ],
    model1: 1,
    model2: 1,
    dataDetail: {},
    filterText: [],
    dataJurusan: [],
    recomendedJurusan: [],
    search: "",
    isSearching: false,
    isSplash: true,
  }),
  mounted() {
    this.getDetail();
    setTimeout(() => {
      this.isSplash = false;
    }, 1000);
  },
  computed: {
    activeRowDetail() {
      return this.filterText.length == 0 && this.isSearching == false;
    },
    activeRowData() {
      return this.filterText.length !== 0 || this.isSearching == true;
    },
  },
  methods: {
    getDetail() {
      let data = {
        id: this.$route.params.id,
      };
      this.$store
        .dispatch("detailJurusan", data)
        .then((data) => {
          let dataDetail = data.data.data[0];
          if (dataDetail) {
            this.dataDetail = dataDetail;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toDetail(id) {
      this.$router.push("/penjurusan").then(() => {
        this.$router.push(`/penjurusan/detail/${id}`);
      });
    },
    backToList() {
      return window.history.length > 2;
    },
    filterKategori(item) {
      this.filterText.push(item.text);
      let filter = this.filterText.toString();
      let data = {
        filter: filter,
      };
      this.$store
        .dispatch("dataJurusan", data)
        .then((data) => {
          let dataJurusan = data.data.data;
          this.dataJurusan = dataJurusan;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    removeFilter(item) {
      let newFilter = [];
      this.filterText.map(function (text) {
        if (item !== text) {
          newFilter.push(text);
        }
      });
      this.filterText = newFilter;
      let filter = this.filterText.toString();
      let data = {
        filter: filter,
      };
      this.$store
        .dispatch("dataJurusan", data)
        .then((data) => {
          let dataJurusan = data.data.data;
          this.dataJurusan = dataJurusan;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    searching() {
      this.isSearching = true;
      let searching = this.search;
      let data = {
        search: searching,
      };
      this.$store
        .dispatch("dataJurusan", data)
        .then((data) => {
          let dataJurusan = data.data.data;
          this.dataJurusan = dataJurusan;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getRecommend() {
      let data = {
        search: this.search,
      };
      this.$store
        .dispatch("dataJurusan", data)
        .then((data) => {
          let recomendedJurusan = data.data.data;
          this.recomendedJurusan = recomendedJurusan;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onClickRecomended(item) {
      this.isSearching = true;
      let data = {
        search: item,
      };
      this.$store
        .dispatch("dataJurusan", data)
        .then((data) => {
          this.search = "";
          let dataJurusan = data.data.data;
          this.dataJurusan = dataJurusan;
          this.pagination = data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style>
.unselectable {
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.left-detail {
  justify-content: center;
  align-items: flex-end;
  height: 50vh;
  z-index: 2;
  width: 40%;
}

.card_1lane {
  padding: 0 15px;
}
.banner_cover {
  width: 60%;
  overflow: hidden;
}

.card_2lane {
  padding: 0 15px;
}

#penjurusan-detail {
  width: 100%;
}

#landing-detail {
  width: 100%;
  height: 40vh;
  background-image: url("../../assets/img/penjurusan/asset1-polos.png");
  background-size: cover;
}

#detail {
  background-color: #dae8ea;
}

#footer {
  color: white;
  background-color: #24182d;
}

#menu-burger {
  display: none !important;
}

.temp_content {
  display: flex;
}
.half {
  width: 50%;
}

.item-recomended {
  cursor: pointer;
}

.item-recomended:hover {
  font-weight: bold;
}

@media (max-width: 1200px) {
}
@media (max-width: 963px) {
}
@media (max-width: 883px) {
  .temp_content {
    display: block;
  }
  .half {
    width: 100%;
  }
  .card_1lane {
    padding: 0;
  }

  .card_2lane {
    padding: 0;
  }
  .label_card {
    font-size: small;
  }
  .left-detail {
    align-items: flex-end;
    width: 100% !important;
    height: max-content;
  }
}
@media (max-width: 768px) {
}
@media (max-width: 576px) {
  .banner_cover {
    display: none;
  }
  /* .banner_cover.rounded-xl.ml-n12.d-flex.justify-center.align-end.v-card.v-sheet.theme--light {
    display: none !important;
  } */
  .left-detail {
    width: 100% !important;
    align-items: center;
    height: max-content;
  }
  .rounded-lg.pa-4.text-center.v-card.v-sheet.theme--dark {
    max-width: 100% !important;
  }
  .search-detail {
    display: none;
  }
  .menu-bar {
    display: none !important;
  }
  #menu-burger {
    display: inline !important;
  }
  .blank_div {
    height: 30vh !important;
  }
}
@media (max-width: 396px) {
}
</style>
